/**
 * Today's wait for the tips, kept from starting over (B109).
 *
 * Today shows the full-screen loader until the tips are ready (the brief has
 * arrived or has failed). The tips' `ready` is a live state: when the brief
 * failed, the page drew, its "Updating your garden" piece mounted and read the
 * brief again, the brief went back to loading, `ready` went false, and Today
 * swapped the page back for the loader, unmounting the piece, which read
 * again on its next mount, and so on until the settle timer ended it. Any
 * failure of the brief did this, a 429 or a 500. The wait for the tips now
 * ends the first time they are ready, for the rest of the visit.
 *
 * Used by: features/today/TodayPage.
 *
 * @module tipsGate
 */

/** What the gate holds between draws. */
export interface TipsGate {
  /** True once the tips have been ready at least once this visit. */
  readyOnce: boolean;
}

/**
 * Whether Today still waits for the tips, and remembers the first time they are ready.
 *
 * @param gate - The gate held between draws (a ref's value); updated here.
 * @param ready - The tips' `ready` right now.
 * @param timedOut - The settle timer has run out.
 * @returns True while Today should show the loader for the tips.
 */
export function waitingForTips(gate: TipsGate, ready: boolean, timedOut: boolean): boolean {
  if (ready) gate.readyOnce = true;
  return !gate.readyOnce && !timedOut;
}
